import { useMemo } from 'react';

var LABEL_LENGTH_TO_WIDTH = 6.9;
var VALUE_LENGTH_TO_WIDTH = 9.8;
var useLongestString = function (options) {
    return useMemo(function () {
        var length = options.reduce(function (longest, label) {
            return label.length > longest ? label.length : longest;
        }, 0);
        return length * VALUE_LENGTH_TO_WIDTH;
    }, [options]);
};

export { LABEL_LENGTH_TO_WIDTH, VALUE_LENGTH_TO_WIDTH, useLongestString };
